<template>
  <section id="MainDefaultNews" class="msection" v-if="filteredNewsList.length > 0">
    <div class="container">
      <div class="msection-header">
        <div class="flex-left">
          <h2 class="msection-title">
            <span class="subtitle"> 동행<strong>뉴스</strong></span>
          </h2>
        </div>
        <div class="flex-right">
					<router-link to="/ko/news/list" class="link-more">
						<span class="text">더보기</span>
						<i class="icon"><icon name="icon-arrow-r" /></i>
					</router-link>
				</div>
      </div>
      <div class="msection-content">
        <div class="main-default-list">
          <article
            v-for="(item, idx) in filteredNewsList"
            :key="idx"
            class="main-default-article"
          >
            <router-link
              :to="`/ko/news/${item.campnNewsId}`"
              class="content-list-item"
            >
              <div class="content-list-desc">
                <div class="content-list-desc-img">
                  <img :src="item.thmbnlImgPtUrl" :alt="item.campnNewsTit" />
                </div>
                <div class="content-list-desc-text">
                  <span class="content-list-desc-title">{{ item.campnNewsTit }}</span>
                  <span class="content-list-desc-date">{{ getTimestampToDateFormat(item.regDt) }}</span>
                </div>
              </div>
            </router-link>
          </article>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters } from "vuex";
import { ACT_GET_NEWS_LIST, ACT_GET_COMMON_CODE_LIST } from "@/store/_act_consts";
import Icon from "@/components/common/Icon";
import {
  getItems,
  lengthCheck,
  getCheckItems,
  setPaging,
  timestampToDateFormat,
} from "@/assets/js/utils";

export default {
  name: "MainDefaultNews",
  components: { Icon },
  data: () => ({
    pageNo: 1,
    pageSize: 3,
    pageListSize: 10,
    totalCount: 0,
    isPaging: false,
    filteredNewsList: [], // 필터링된 뉴스 리스트
    selectedCategory: '', // 선택된 카테고리
    categories: [], // 공통 코드에서 가져온 카테고리 리스트
    newsList: [], // 전체 뉴스 리스트 (초기 데이터)
    
  }),
  computed: {
    ...mapGetters("common", ["isMobile", "commonCode", "campn"]),
    campnId() {
      return this.campn.campnId;
    },
  },
  created() {
    this.getCategories(); // 공통 코드 가져오기
    this.getNewsList(); // 초기 로드 시 전체 뉴스 가져오기
  },
  methods: {
    // 공통 코드에서 카테고리 목록 가져오기
    getCategories() {
      this.$store
        .dispatch(`common/${ACT_GET_COMMON_CODE_LIST}`, {})
        .then((res) => {
          if (lengthCheck(res)) {
            this.categories = getItems(res).filter(item => 
              ['1506001', '1506002'].includes(item.dcd) // 행사(1506001), 홍보 마케팅(1506002)
            );
          }
        })
        .catch((e) => {
          console.error("Failed to fetch common codes:", e);
        });
    },
    // 뉴스 리스트를 한 번만 가져오기
    getNewsList() {
      const params = {
        campnId: this.campnId,
        pageNo: this.pageNo,
        pageSize: this.pageSize,
      };

      this.$store
        .dispatch(`news/${ACT_GET_NEWS_LIST}`, params)
        .then((res) => {
          if (lengthCheck(res)) {
            this.newsList = getCheckItems(res); // 전체 뉴스 리스트 저장
            this.filteredNewsList = [...this.newsList]; // 초기에는 전체 리스트로 설정
            this.isPaging = this.newsList.length > 0;
            setPaging(this, res);
          } else {
            this.newsList = [];
            this.filteredNewsList = [];
            this.isPaging = false;
          }
        })
        .catch((e) => {
          console.error("Error fetching news list:", e);
          this.newsList = [];
          this.filteredNewsList = [];
        });
    },
    getTimestampToDateFormat(timestamp) {
      return timestampToDateFormat(timestamp, "yyyy-MM-dd");
    },
    // 카테고리 필터링 (클라이언트 측)
    filterNews(category) {
      this.selectedCategory = category;
      if (category === '') {
        // "전체" 버튼 클릭 시 모든 뉴스 표시
        this.filteredNewsList = [...this.newsList];
      } else {
        // 선택된 카테고리에 따라 필터링
        this.filteredNewsList = this.newsList.filter(item => item.ctgrDcd === category);
      }
    },
  },
};
</script>

<style scoped>
.category-filter-buttons {
  margin-bottom: 20px;
  display: flex;
  gap: 10px;
}

/* 기본 버튼 스타일 */
.btn-white-outline {
  background-color: #fcfbf9;
  color: rgb(8, 8, 8);
  border: 1px solid #faf9f7;
  border-radius: 15px;
  padding: 5px 10px;
  transition: all 0.3s ease;
}

/* 활성화된 버튼 스타일 */
.btn-white-outline.is-active {
  background-color: #ffae00;
  color: white;
  border-color: #ff9900;
}

/* 비활성화 버튼 호버 시 */
.btn-white-outline:hover:not(.is-active) {
  background-color: #f0f0f0;
}
</style>